module.exports = __webpack_public_path__ + "img/threeD-cover-1.6bb7e4dd.png";